import { Hex2 } from './types';

export const decToHex2 = (dec: number) =>
  Math.min(255, Math.max(0, dec)).toString(16).padStart(2, '0') as Hex2;
